// The PDP trail is rendered by the PH Breadcrumbs app block, whose own home crumb is disabled:
// its label is resolved against the app extension's locales, not the theme's, so it prints "Home"
// in every language. The theme renders the translated home crumb instead (_jd-breadcrumb) and this
// script moves it into the app's <nav>, so the trail stays one line and one landmark — the two
// blocks are siblings in a column flex container and cannot sit side by side otherwise.
(() => {
  const nav = document.querySelector('.ba-breadcrumb');
  const home = document.querySelector('[data-jd-breadcrumb-home] .jd-breadcrumb__link');

  if (!nav || !home) return;

  // Clone the app's own separator rather than hardcoding a glyph, so the injected crumb always
  // matches whatever separator the app block is configured with.
  const separator = nav.querySelector('span:not(.ba-last-crumb)');
  const divider = separator ? separator.cloneNode(true) : document.createElement('span');

  if (!separator) divider.textContent = '•';

  nav.prepend(home, divider);
})();
